import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import { IconButton } from 'components/Button';

import './index.sass';

const { block, el } = bem( 'counter' )

export default ( { amount, maxAmount, updateItem }) => {

    const onClickMinus = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (amount === 0 || maxAmount === 0) {
            return;
        }
        updateItem(-1);
    }

    const onClickPlus = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (amount >= maxAmount) {
            return;
        }
        updateItem();
    }

    return <div className={ block({ 'disabled': maxAmount <= 0}) }>
        <IconButton mod={ 'transparent-gold' }
                    name={ 'minus' }
                    className={ el( 'decrement', { 'disabled': (amount === 0) } ) }
                    onClick={onClickMinus} />
        <div className={ el( 'amount' ) }>
            <Text>{ Math.min( amount, maxAmount) }</Text>
        </div>
        <IconButton mod={ 'transparent-gold' }
                    name={ 'plus' }
                    className={ el( 'increment', { 'disabled': (amount === maxAmount) }) }
                    onClick={ onClickPlus } />
    </div>
}
